import { Button, Link } from "@amzn/awsui-components-react";
import React from 'react';

export default function ButtonBasedReportHeaderAction(props: {
    headerAction: any,
    headerName: string,
    externalLink?: string,
    disabled?: boolean
}) {
    // When disabled (e.g. the selected report version did not produce this report type), render a
    // non-navigating, greyed-out header so the card is visibly unavailable rather than clickable.
    if (props.disabled) {
        return (<Button variant='inline-link' disabled>{props.headerName}</Button>);
    }
    return (<Button variant='inline-link' onClick={props.headerAction}>
        {!!props.externalLink ?
            (<Link external href={props.externalLink} target="_blank" fontSize='heading-m'>{props.headerName}</Link>)
            :
            (<Link fontSize='heading-m'>{props.headerName}</Link>)}
    </Button>)
}